import React, { useEffect, useState } from "react";

import Loading from "./loading";
import MspUserManagement from "./MspUserManagement";
import OrgUserManagement from "./OrgUserManagement";
import OnPremUserManagement from "./OnPremUserManagement";

const UserContent = ({ userId, closeDrawerCallback = null }) => {
  const runningContext = process.env.REACT_APP_RUNNING_CONTEXT;

  const [isLoading, setIsLoading] = useState(true);
  const [isMspView, setIsMspView] = useState(null);
  const breadcrumbs = JSON.parse(localStorage.getItem("selectBreadcrumbs"));
  const hasManageOrg = breadcrumbs.realm?.hasManageOrg === true;
  const realmId = breadcrumbs.realm?.id ?? null;
  const orgsId = breadcrumbs.orgs?.id ?? null;

  let entId = null;
  let orgId = null;

  if (hasManageOrg) {
    entId = realmId;
    if (orgsId) {
      orgId = orgsId;
    }
  } else {
    orgId = realmId;
  }

  useEffect(() => {
    if (!userId) {
      return;
    }

    setIsLoading(true);
    const stored = localStorage.getItem("selectBreadcrumbs");
    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        const realm = parsed?.realm;
        const hasRealm = realm && Object.keys(realm).length > 0;
        const hasManageOrg = realm?.hasManageOrg === true;
        const hasNoOrgs = !parsed?.orgs || Object.keys(parsed.orgs).length === 0;
        const hasNoSite = !parsed?.site || Object.keys(parsed.site).length === 0;
        const showMspView = hasRealm && hasManageOrg && hasNoOrgs && hasNoSite;
        setIsMspView(showMspView);
      } catch (err) {
        console.error("Invalid JSON in selectBreadcrumbs:", err);
        setIsMspView(false);
      }
    } else {
      setIsMspView(false);
    }

    setIsLoading(false);
  }, []);

  if (isLoading) {
    return <Loading />;
  }

  if (runningContext === "premises") {
    return <OnPremUserManagement
      orgId={orgId}
      userId={userId}
      closeDrawerCallback={closeDrawerCallback} />;
  }

  return isMspView ? (
    <MspUserManagement
      entId={entId}
      userId={userId}
      closeDrawerCallback={closeDrawerCallback} />
  ) : (
    <OrgUserManagement
      entId={entId}
      orgId={orgId}
      userId={userId}
      closeDrawerCallback={closeDrawerCallback} />
  );
}

export default UserContent;